export default {
  zh: {
    createPload:'Give your guild a name',
    createBtnText:'Apply to Create',
    createGuildText:"Create a Guild",
    guildInformation:"Agency Information",
    guildName:"Guild Name",
    guildId:"Agency ID",
    countryName:"Country",
    timeCreated:"Time Created",
    guildLeader:"Agency Leader",
    leader:"Leader",
    view:"View",
    underReview:"Under Review",
    tasks:"Tasks",
    ranking:"Ranking",
    hostRanking:"Host Ranking",
    guildManagement:"Agency Management",
    manageHost:"Manage Host",
    host:"Host",
    admin:"Admin",
    liveDurationthisMonth:"Live Duration this Month",
    targetThisMonth:"Target this Month",
    target:"Target",
    successful:"The operation was successful",
    hosts:"Hosts",
    domTitle:"Host System",
    leaderAdmins:"Leader & Admins",
    hostList:"Host List",
    inviteNewHost:"Invite New Host",
    findinthe:"Agency Information",
    cteratInfoTitle:"Agency Information",
    agencyName:"Agency Name",
    realName:"Owner Real Name",
    whatsApp:"WhatsApp",
    whyNeedName:"Real name is only used as approval information and will not be displayed in the APP.",
    next:"Next",
    cancel:'Cancel',
    yes: "Confirm",
    checkInfuyou:"Check your Information",
    ininyouhost:"Invite your hosts",
    submit:"Submit",
    enterAgencyName:"Enter Agency Name",
    enterRealName:"Enter Real Name",
    enterWhatsApp:"Enter WhatsApp",
    submitSuccess:"Submitted Successfully",
    willpossible:"We will process it as soon as possible.",
    thankyou:"Thank you for your patience",
    quitagency:"Quit Agency",
    min:"min",
    hour:"h",
    intheHostText:"You are just a host member, waiting for the Leader to submit",
    joinapplication:'Inviter Review',
    shareText:"Get Your Link (only share in app)",
    submitTip:"You need to have 10 hosts to submit",
    passText:"Pass",
    toOneUser:"If you want to cancel your angcy, please contact our administrator",
    myInfoText:"My Info",
    bankIdText:"Account",
    bankNameText:"BankName",
    payeeName:"PayeeName",
    onMicTime:"On mic time",
    days: 'Day',
    tableItem: ['Info', 'Host', 'Data'],
  },
  en: {
    createPload:'Give your guild a name',
    createBtnText:'Apply to Create',
    createGuildText:"Create a Guild",
    guildInformation:"Agency Information",
    guildName:"Guild Name",
    guildId:"Agency ID",
    countryName:"Country",
    timeCreated:"Time Created",
    guildLeader:"Agency Leader",
    leader:"Leader",
    view:"View",
    underReview:"Under Review",
    tasks:"Tasks",
    ranking:"Ranking",
    hostRanking:"Host Ranking",
    guildManagement:"Agency Management",
    manageHost:"Manage Host",
    host:"Host",
    admin:"Admin",
    liveDurationthisMonth:"Live Duration this Month",
    targetThisMonth:"Target this Month",
    target:"Target",
    successful:"The operation was successful",
    hosts:"Hosts",
    domTitle:"Host System",
    leaderAdmins:"Leader & Admins",
    hostList:"Host List",
    inviteNewHost:"Invite New Host",
    findinthe:"Agency Information",
    cteratInfoTitle:"Agency Information",
    agencyName:"Agency Name",
    realName:"Owner Real Name",
    whatsApp:"WhatsApp",
    whyNeedName:"Real name is only used as approval information and will not be displayed in the APP.",
    next:"Next",
    cancel:'Cancel',
    yes: "Confirm",
    checkInfuyou:"Check your Information",
    ininyouhost:"Invite your hosts",
    submit:"Submit",
    enterAgencyName:"Enter Agency Name",
    enterRealName:"Enter Real Name",
    enterWhatsApp:"Enter WhatsApp",
    submitSuccess:"Submitted Successfully",
    willpossible:"We will process it as soon as possible.",
    thankyou:"Thank you for your patience",
    quitagency:"Quit Agency",
    min:"min",
    hour:"h",
    intheHostText:"You are just a host member, waiting for the Leader to submit",
    joinapplication:'Inviter Review',
    shareText:"Get Your Link (only share in app)",
    submitTip:"You need to have 10 hosts to submit",
    passText:"Pass",
    toOneUser:"If you want to cancel your angcy, please contact our administrator",
    hostTitleText:"Host Number",
    quitText:"If you cancel your host membership, 25% of the target will be deducted.",
    myInfoText:"My Info",
    bankIdText:"Account",
    bankNameText:"BankName",
    payeeName:"PayeeName",
    saveChanges:"Save Changes",
    onMicTime:"On mic time",
    days: 'Day',
    tableItem: ['Info', 'Host', 'Data'],
  },
  ar: { // 阿拉伯
    createPload:'امنح نقابتك اسما',
    createBtnText:'تطبيق لإنشاء',
    createGuildText:"إنشاء نقابة",
    guildInformation:"معلومات الوكالة",
    guildName:"اسم النقابة",
    guildId:"معرف الوكالة",
    countryName:"الدولة",
    timeCreated:"وقت الانشاء",
    guildLeader:"قائد الوكالة",
    leader:"زعيم",
    view:"عرض",
    underReview:"تحت المراجعه",
    tasks:"المهام",
    ranking:"ترتيب",
    hostRanking:"تصنيف المضيف",
    guildManagement:"إدارة الوكالة",
    manageHost:"إدارة المضيفين",
    host:"مضيف",
    admin:"المشرف",
    liveDurationthisMonth:"المدة الحية هذا الشهر",
    targetThisMonth:"الهدف هذا الشهر",
    target:"التارجت",
    successful:"العملية كانت ناجحه",
    hosts:"المضيفين",
    domTitle:" نظام المضيف",
    leaderAdmins:"المالك و الادمن",
    hostList:"قائمة المضيفين",
    inviteNewHost:"دعوة مضيف جديد",
    findinthe:"معلومات الوكالة",
    cteratInfoTitle:"معلومات الوكالة",
    agencyName:"اسم الوكالة",
    realName:"اسم الوكيل",
    whatsApp:"واتساب ",
    whyNeedName:"يتم استخدام الاسم الحقيقي فقط كمعلومات موافقة ولن يتم عرضه في التطبيق.",
    next:"تقديم",
    cancel: 'إلغاء',
    yes: "تأكيد",
    checkInfuyou:"تحقق من معلوماتك",
    ininyouhost:"دعوة المضيفين",
    submit:"إرسال",
    enterAgencyName:"أدخل اسم الوكالة",
    enterRealName:"ادخل الاسم الحقيقي",
    enterWhatsApp:"ادخل رقم الواتساب ",
    submitSuccess:"تم الإرسال بنجاح",
    willpossible:"سنقوم بمعالجتها في أقرب وقت ممكن.",
    thankyou:"شكرا لك على صبرك.",
    quitagency:"استقالة الوكالة",
    min:"دقيقة",
    hour:"ساعة",
    intheHostText:"لقد اصبحت عضو في الوكاله، يرجى انتضار مدير الوكاله لتسليم الطلب",
    joinapplication:"طلبات الانضمام",
    shareText:"احصل على رابط الدعوة(يعمل الرابط فقط داخل التطبيق)",
    submitTip:"لإكمال التقديم يجب عليك قبول 10 مضيفين",
    passText:"مقبول",
    toOneUser:"لحذف وكالتك يرجي التواصل مع المسؤول، ايدي المسؤول:977239",
    hostTitleText:"عدد المضيفين",
    quitText:"اذا قمت بمغادرة الوكاله، سيتم خصم25% من التارجت الخاص بك",
    myInfoText:"معلوماتي",
    bankIdText:"اسم البنك",
    bankNameText:"رقم الحساب",
    payeeName:"الاسم",
    saveChanges:"حفظ التغييرات ",
    onMicTime:"وقت المايك",
    days: 'أيام',
    tableItem: ['معلومات', 'مضيف', 'بيانات'],
  },
  tr:{ //土耳其
    createPload:'Loncanıza bir isim verin',
    createBtnText:"Oluşturmak için Uygula",
    createGuildText:"Bir Lonca Oluştur",
    guildInformation:"Ajans Bilgileri",
    guildName:"Lonca Adı",
    guildId:"Ajans ID",
    countryName:"Ülke",
    timeCreated:"Oluşturulma Zamanı",
    guildLeader:"Ajans Lideri",
    leader:"Lider",
    view:"Profil",
    underReview:"İnceleme Altında",
    tasks:"Görev",
    ranking:"Sıralama",
    hostRanking:"Yayıncı Sıralaması",
    guildManagement:"Ajans Yönetimi",
    manageHost:"Yayıncıları Yönet",
    host:"Yayıncı",
    admin:"Admin",
    liveDurationthisMonth:"Bu Ay Süre",
    targetThisMonth:"Bu Ayı Hedefleyin",
    target:"Kota",
    successful:"İşlem Başarılı Oldu",
    hosts:"Yayıncılar",
    domTitle:"Ajans Sistemi",
    leaderAdmins:"Lider ve Yöneticiler",
    hostList:"Ana Bilgisayar Listesi",
    inviteNewHost:"Yeni Ev Sahibi Davet Et",
    findinthe:"Ajans Bilgileri",
    cteratInfoTitle:"Ajans Bilgilerini Girin",
    agencyName:"Ajans Adı",
    realName:"Kullanıcı Adı",
    whatsApp:"İletişim",
    whyNeedName:"Kullanıcı Adı yalnızca onay bilgisi olarak kullanılır. Uygulamada görüntülenemez.",
    next:"Sonraki",
    cancel:'İptal',
    yes: "Doğrula",
    checkInfuyou:"Bilgilerinizi Kontrol Edin",
    ininyouhost:"Ev sahiplerinizi davet edin",
    submit:"Gönder",
    enterAgencyName:"Ajans Adını Girin",
    enterRealName:"Kullanıcı Adı Girin",
    enterWhatsApp:"WhatsApp'a girin",
    submitSuccess:"Başarıyla Gönderildi",
    willpossible:"En kısa sürede işleme koyacağız.",
    thankyou:"Sabrınız için teşekkür ederiz",
    quitagency:"Ajanstan Çık",
    min:"Dk",
    hour:"S",
    intheHostText:"Siz sadece yayıncı üyesisiniz , Liderin göndermesini bekliyorsunuz.",
    joinapplication:"Davet Bildirimi",
    shareText:"Linkinizi alın (Sadece uygulama içinde paylaşın)",
    submitTip:"Göndermek için 10 yayıncıya sahip olmanız gerekir",
    passText:"Aktif",
    toOneUser:"Ajansınızı İptal etmek istiyorsanız lütfen bizimle iletişime geçin yönetici ID:SELMAN",
    hostTitleText:"Yayıncı Numarası",
    quitText:"Ajanstan ayrılır yayıncılığınızı  iptal ederseniz, hedefin %25'i düşülecektir.",
    myInfoText:"Bilgilerim",
    bankIdText:"İban",
    bankNameText:"Banka İsmi",
    payeeName:"İsim Soyisim",
    saveChanges:"Değişiklikleri Kaydet",
    onMicTime:"Mic Aktiflik",
    days: 'gün',
    tableItem: ['Bilgi', 'Ajans Sahibi', 'Veri'],
  },
  pt: {
    createPload: "Dê um nome à sua guilda",
    createBtnText: "Aplicar para Criar",
    createGuildText: "Criar uma Guilda",
    guildInformation: "Informações da Agência",
    guildName: "Nome da Guilda",
    guildId: "ID da Agência",
    countryName: "País",
    timeCreated: "Data de Criação",
    guildLeader: "Líder da Agência",
    leader: "Líder",
    view: "Ver",
    underReview: "Em Revisão",
    tasks: "Tarefas",
    ranking: "Ranking",
    hostRanking: "Ranking de Hóspedes",
    guildManagement: "Gestão da Agência",
    manageHost: "Gerenciar Hóspede",
    host: "Hóspede",
    admin: "Admin",
    liveDurationthisMonth: "Duração ao vivo deste mês",
    targetThisMonth: "Meta deste mês",
    target: "Meta",
    successful: "A operação foi bem-sucedida",
    hosts: "Hóspedes",
    domTitle: "Sistema de Hóspedes",
    leaderAdmins: "Líder & Admins",
    hostList: "Lista de Hóspedes",
    inviteNewHost: "Convidar Novo Hóspede",
    findinthe: "Informações da Agência",
    cteratInfoTitle: "Informações da Agência",
    agencyName: "Nome da Agência",
    realName: "Nome Real do Proprietário",
    whatsApp: "WhatsApp",
    whyNeedName: "O nome real é utilizado apenas como informação de aprovação e não será exibido no APP.",
    next: "Próximo",
    cancel: "Cancelar",
    yes: "Confirmar",
    checkInfuyou: "Verifique suas Informações",
    ininyouhost: "Convide seus Hóspedes",
    submit: "Enviar",
    enterAgencyName: "Digite o Nome da Agência",
    enterRealName: "Digite o Nome Real",
    enterWhatsApp: "Digite o WhatsApp",
    submitSuccess: "Enviado com Sucesso",
    willpossible: "Processaremos o mais rápido possível.",
    thankyou: "Obrigado pela sua paciência",
    quitagency: "Sair da Agência",
    min: "min",
    hour: "h",
    intheHostText: "Você é apenas um membro do hóspede, aguardando o líder enviar",
    joinapplication: "Revisão do Convidado",
    shareText: "Obtenha seu Link (somente compartilhe no app)",
    submitTip: "Você precisa de 10 hóspedes para enviar",
    passText: "Aprovar",
    toOneUser: "Se você deseja cancelar sua agência, entre em contato com nosso administrador",
    hostTitleText: "Número de Hóspedes",
    quitText: "Se você cancelar sua associação ao hóspede, 25% da meta será descontada.",
    myInfoText: "Minhas Informações",
    bankIdText: "Conta",
    bankNameText: "Nome do Banco",
    payeeName: "Nome do Beneficiário",
    saveChanges: "Salvar Alterações",
    onMicTime: "Tempo no microfone",
    days: "Dia",
    tableItem: ['Info', 'Host', 'Data'],
  },
  id: {
    createPload: "Berikan nama untuk guild Anda",
    createBtnText: "Ajukan untuk Membuat",
    createGuildText: "Buat Guild",
    guildInformation: "Informasi Agensi",
    guildName: "Nama Guild",
    guildId: "ID Agensi",
    countryName: "Negara",
    timeCreated: "Waktu Dibuat",
    guildLeader: "Pemimpin Agensi",
    leader: "Pemimpin",
    view: "Lihat",
    underReview: "Sedang Ditinjau",
    tasks: "Tugas",
    ranking: "Peringkat",
    hostRanking: "Peringkat Host",
    guildManagement: "Manajemen Agensi",
    manageHost: "Kelola Host",
    host: "Host",
    admin: "Admin",
    liveDurationthisMonth: "Durasi Siaran Bulan Ini",
    targetThisMonth: "Target Bulan Ini",
    target: "Target",
    successful: "Operasi berhasil",
    hosts: "Host",
    domTitle: "Sistem Host",
    leaderAdmins: "Pemimpin & Admin",
    hostList: "Daftar Host",
    inviteNewHost: "Undang Host Baru",
    findinthe: "Informasi Agensi",
    cteratInfoTitle: "Informasi Agensi",
    agencyName: "Nama Agensi",
    realName: "Nama Pemilik Asli",
    whatsApp: "WhatsApp",
    whyNeedName: "Nama asli hanya digunakan sebagai informasi persetujuan dan tidak akan ditampilkan di Aplikasi.",
    next: "Berikutnya",
    cancel: "Batal",
    yes: "Konfirmasi",
    checkInfuyou: "Periksa Informasi Anda",
    ininyouhost: "Undang Host Anda",
    submit: "Kirim",
    enterAgencyName: "Masukkan Nama Agensi",
    enterRealName: "Masukkan Nama Asli",
    enterWhatsApp: "Masukkan WhatsApp",
    submitSuccess: "Berhasil Dikirim",
    willpossible: "Kami akan memprosesnya secepat mungkin.",
    thankyou: "Terima kasih atas kesabaran Anda",
    quitagency: "Keluar dari Agensi",
    min: "menit",
    hour: "jam",
    intheHostText: "Anda hanya anggota host, menunggu pemimpin untuk mengirimkan",
    joinapplication: "Tinjauan Undangan",
    shareText: "Dapatkan Tautan Anda (hanya bagikan di aplikasi)",
    submitTip: "Anda perlu memiliki 10 host untuk mengirimkan",
    passText: "Lulus",
    toOneUser: "Jika Anda ingin membatalkan agensi Anda, silakan hubungi administrator kami",
    hostTitleText: "Jumlah Host",
    quitText: "Jika Anda membatalkan keanggotaan host Anda, 25% dari target akan dipotong.",
    myInfoText: "Informasi Saya",
    bankIdText: "Akun",
    bankNameText: "Nama Bank",
    payeeName: "Nama Penerima",
    saveChanges: "Simpan Perubahan",
    onMicTime: "Waktu di mikrofon",
    days: "Hari",
    tableItem: ['Info', 'Host', 'Data'],
  },
  uz: {
    createPload: "Gildiyangizga nom bering",
    createBtnText: "Yaratish uchun ariza berish",
    createGuildText: "Guild yaratish",
    guildInformation: "Agentlik ma'lumotlari",
    guildName: "Guild nomi",
    guildId: "Agentlik ID",
    countryName: "Mamlakat",
    timeCreated: "Yaratilgan vaqt",
    guildLeader: "Agentlik rahbari",
    leader: "Rahbar",
    view: "Ko'rish",
    underReview: "Ko'rib chiqilmoqda",
    tasks: "Vazifalar",
    ranking: "Reyting",
    hostRanking: "Host reytingi",
    guildManagement: "Agentlikni boshqarish",
    manageHost: "Hostni boshqarish",
    host: "Host",
    admin: "Admin",
    liveDurationthisMonth: "Ushbu oyda jonli efir vaqti",
    targetThisMonth: "Ushbu oydagi maqsad",
    target: "Maqsad",
    successful: "Amaliyot muvaffaqiyatli bajarildi",
    hosts: "Hostlar",
    domTitle: "Host tizimi",
    leaderAdmins: "Rahbar & Adminlar",
    hostList: "Hostlar ro'yxati",
    inviteNewHost: "Yangi Hostni taklif qilish",
    findinthe: "Agentlik ma'lumotlari",
    cteratInfoTitle: "Agentlik ma'lumotlari",
    agencyName: "Agentlik nomi",
    realName: "Egasining haqiqiy ismi",
    whatsApp: "WhatsApp",
    whyNeedName: "Haqiqiy ism faqat tasdiqlash ma'lumotlari sifatida ishlatiladi va ilovada ko'rsatilmaydi.",
    next: "Keyingi",
    cancel: "Bekor qilish",
    yes: "Tasdiqlash",
    checkInfuyou: "Ma'lumotlaringizni tekshiring",
    ininyouhost: "Hostlaringizni taklif qiling",
    submit: "Yuborish",
    enterAgencyName: "Agentlik nomini kiriting",
    enterRealName: "Haqiqiy ismingizni kiriting",
    enterWhatsApp: "WhatsApp raqamingizni kiriting",
    submitSuccess: "Muvaffaqiyatli yuborildi",
    willpossible: "Tez orada uni qayta ko'rib chiqamiz.",
    thankyou: "Sabr-toqat qilganingiz uchun rahmat",
    quitagency: "Agentlikdan chiqish",
    min: "min",
    hour: "soat",
    intheHostText: "Siz faqat host a'zosisiz, rahbar tomonidan yuborilishini kutyapsiz",
    joinapplication: "Taklifni ko'rib chiqish",
    shareText: "Havolani oling (faqat ilovada ulashing)",
    submitTip: "Yuborish uchun 10 hostga ega bo'lishingiz kerak",
    passText: "O'tkazish",
    toOneUser: "Agar agentlikni bekor qilmoqchi bo'lsangiz, iltimos, administratorimiz bilan bog'laning",
    hostTitleText: "Host soni",
    quitText: "Agar host a'zoligingizni bekor qilsangiz, maqsadning 25% miqdori kamaytiriladi.",
    myInfoText: "Mening ma'lumotlarim",
    bankIdText: "Hisob",
    bankNameText: "Bank nomi",
    payeeName: "To'lov oluvchining ismi",
    saveChanges: "O'zgartirishlarni saqlash",
    onMicTime: "Mikrofon vaqti",
    days: "Kun",
    tableItem: ['Info', 'Host', 'Data'],
  },
  ru: {
    createPload: "Дайте вашей гильдии название",
    createBtnText: "Подать заявку на создание",
    createGuildText: "Создать Гильдию",
    guildInformation: "Информация о агентстве",
    guildName: "Название гильдии",
    guildId: "ID агентства",
    countryName: "Страна",
    timeCreated: "Дата создания",
    guildLeader: "Лидер агентства",
    leader: "Лидер",
    view: "Просмотр",
    underReview: "На рассмотрении",
    tasks: "Задачи",
    ranking: "Рейтинг",
    hostRanking: "Рейтинг хостов",
    guildManagement: "Управление агентством",
    manageHost: "Управление хостом",
    host: "Хост",
    admin: "Админ",
    liveDurationthisMonth: "Длительность эфира в этом месяце",
    targetThisMonth: "Цель на этот месяц",
    target: "Цель",
    successful: "Операция выполнена успешно",
    hosts: "Хосты",
    domTitle: "Система хостов",
    leaderAdmins: "Лидер и админы",
    hostList: "Список хостов",
    inviteNewHost: "Пригласить нового хоста",
    findinthe: "Информация об агентстве",
    cteratInfoTitle: "Информация об агентстве",
    agencyName: "Название агентства",
    realName: "Настоящее имя владельца",
    whatsApp: "WhatsApp",
    whyNeedName: "Настоящее имя используется только для одобрения и не будет отображаться в приложении.",
    next: "Далее",
    cancel: "Отмена",
    yes: "Подтвердить",
    checkInfuyou: "Проверьте свою информацию",
    ininyouhost: "Пригласите своих хостов",
    submit: "Отправить",
    enterAgencyName: "Введите название агентства",
    enterRealName: "Введите настоящее имя",
    enterWhatsApp: "Введите WhatsApp",
    submitSuccess: "Успешно отправлено",
    willpossible: "Мы обработаем это как можно скорее.",
    thankyou: "Спасибо за ваше терпение",
    quitagency: "Покинуть агентство",
    min: "мин",
    hour: "ч",
    intheHostText: "Вы только член хоста, ожидаете, чтобы лидер отправил",
    joinapplication: "Обзор приглашения",
    shareText: "Получите вашу ссылку (только для обмена в приложении)",
    submitTip: "Для отправки нужно иметь 10 хостов",
    passText: "Пропустить",
    toOneUser: "Если вы хотите отменить ваше агентство, пожалуйста, свяжитесь с нашим администратором",
    hostTitleText: "Количество хостов",
    quitText: "Если вы отмените свое членство в хосте, будет вычтено 25% от цели.",
    myInfoText: "Моя информация",
    bankIdText: "Аккаунт",
    bankNameText: "Название банка",
    payeeName: "Имя получателя",
    saveChanges: "Сохранить изменения",
    onMicTime: "Время на микрофоне",
    days: "День",
    tableItem: ['Info', 'Host', 'Data'],
  },
  fa: {
    createPload: "به گیلد خود یک نام بدهید",
    createBtnText: "برای ایجاد درخواست دهید",
    createGuildText: "ایجاد یک گیلد",
    guildInformation: "اطلاعات آژانس",
    guildName: "نام گیلد",
    guildId: "آی دی آژانس",
    countryName: "کشور",
    timeCreated: "زمان ایجاد",
    guildLeader: "رهبر آژانس",
    leader: "رهبر",
    view: "مشاهده",
    underReview: "در حال بررسی",
    tasks: "وظایف",
    ranking: "رتبه بندی",
    hostRanking: "رتبه بندی میزبان",
    guildManagement: "مدیریت آژانس",
    manageHost: "مدیریت میزبان",
    host: "میزبان",
    admin: "مدیر",
    liveDurationthisMonth: "مدت زمان پخش زنده این ماه",
    targetThisMonth: "هدف این ماه",
    target: "هدف",
    successful: "عملیات با موفقیت انجام شد",
    hosts: "میزبان‌ها",
    domTitle: "سیستم میزبان",
    leaderAdmins: "رهبر و مدیران",
    hostList: "لیست میزبان‌ها",
    inviteNewHost: "دعوت از میزبان جدید",
    findinthe: "اطلاعات آژانس",
    cteratInfoTitle: "اطلاعات آژانس",
    agencyName: "نام آژانس",
    realName: "نام واقعی صاحب",
    whatsApp: "واتساپ",
    whyNeedName: "نام واقعی فقط به عنوان اطلاعات تاییدیه استفاده می‌شود و در اپلیکیشن نمایش داده نخواهد شد.",
    next: "بعدی",
    cancel: "لغو",
    yes: "تأیید",
    checkInfuyou: "اطلاعات خود را بررسی کنید",
    ininyouhost: "میزبان‌های خود را دعوت کنید",
    submit: "ارسال",
    enterAgencyName: "نام آژانس را وارد کنید",
    enterRealName: "نام واقعی را وارد کنید",
    enterWhatsApp: "واتساپ را وارد کنید",
    submitSuccess: "با موفقیت ارسال شد",
    willpossible: "ما این را در اسرع وقت پردازش خواهیم کرد.",
    thankyou: "از صبر شما سپاسگزاریم",
    quitagency: "خروج از آژانس",
    min: "دقیقه",
    hour: "ساعت",
    intheHostText: "شما تنها عضو میزبان هستید و منتظر ارسال از طرف رهبر هستید",
    joinapplication: "بررسی دعوتنامه",
    shareText: "لینک خود را بگیرید (فقط در اپلیکیشن به اشتراک بگذارید)",
    submitTip: "برای ارسال نیاز به 10 میزبان دارید",
    passText: "قبول",
    toOneUser: "اگر می‌خواهید آژانس خود را لغو کنید، لطفاً با مدیر ما تماس بگیرید",
    hostTitleText: "تعداد میزبان‌ها",
    quitText: "اگر عضویت میزبان خود را لغو کنید، 25٪ از هدف کم خواهد شد.",
    myInfoText: "اطلاعات من",
    bankIdText: "حساب",
    bankNameText: "نام بانک",
    payeeName: "نام دریافت‌کننده",
    saveChanges: "ذخیره تغییرات",
    onMicTime: "زمان در میکروفون",
    days: "روز",
    tableItem: ['Info', 'Host', 'Data'],
  },
  ur: {
    createPload:'اپنی گلڈ کا نام دیں',
    createBtnText:'تخلیق کے لیے درخواست دیں',
    createGuildText:"گلڈ تخلیق کریں",
    guildInformation:"ایجنسی کی معلومات",
    guildName:"گلڈ کا نام",
    guildId:"ایجنسی ID",
    countryName:"ملک",
    timeCreated:"تخلیق کا وقت",
    guildLeader:"ایجنسی لیڈر",
    leader:"لیڈر",
    view:"دیکھیں",
    underReview:"جائزہ کے تحت",
    tasks:"کام",
    ranking:"درجہ بندی",
    hostRanking:"میزبان درجہ بندی",
    guildManagement:"ایجنسی انتظامیہ",
    manageHost:"میزبان کا انتظام کریں",
    host:"میزبان",
    admin:"ایڈمن",
    liveDurationthisMonth:"اس ماہ کی لائیو مدت",
    targetThisMonth:"اس ماہ کا ہدف",
    target:"ہدف",
    successful:"آپریشن کامیاب رہا",
    hosts:"میزبان",
    domTitle:"میزبان نظام",
    leaderAdmins:"لیڈر اور ایڈمنز",
    hostList:"میزبان کی فہرست",
    inviteNewHost:"نئے میزبان کو مدعو کریں",
    findinthe:"ایجنسی کی معلومات",
    cteratInfoTitle:"ایجنسی کی معلومات",
    agencyName:"ایجنسی کا نام",
    realName:"مالک کا اصل نام",
    whatsApp:"واٹس ایپ",
    whyNeedName:"اصل نام صرف منظوری کے لیے استعمال ہوتا ہے اور اسے ایپ میں ظاہر نہیں کیا جائے گا۔",
    next:"اگلا",
    cancel:'منسوخ کریں',
    yes: "تصدیق کریں",
    checkInfuyou:"اپنی معلومات چیک کریں",
    ininyouhost:"اپنے میزبانوں کو مدعو کریں",
    submit:"جمع کروائیں",
    enterAgencyName:"ایجنسی کا نام درج کریں",
    enterRealName:"اصل نام درج کریں",
    enterWhatsApp:"واٹس ایپ درج کریں",
    submitSuccess:"کامیابی سے جمع کر دیا گیا",
    willpossible:"ہم اسے جلد از جلد پروسیس کریں گے۔",
    thankyou:"آپ کے صبر کا شکریہ",
    quitagency:"ایجنسی چھوڑیں",
    min:"منٹ",
    hour:"گھنٹہ",
    intheHostText:"آپ صرف ایک میزبان ممبر ہیں، لیڈر کے جمع کرانے کا انتظار کر رہے ہیں",
    joinapplication:'مدعو کنندہ کا جائزہ',
    shareText:"اپنا لنک حاصل کریں (صرف ایپ میں شیئر کریں)",
    submitTip:"جمع کرانے کے لیے آپ کے پاس 10 میزبان ہونے چاہئیں",
    passText:"منظور",
    toOneUser:"اگر آپ اپنی ایجنسی منسوخ کرنا چاہتے ہیں، تو براہ کرم ہمارے منتظم سے رابطہ کریں",
    hostTitleText:"میزبان کی تعداد",
    quitText:"اگر آپ اپنی میزبان ممبرشپ منسوخ کرتے ہیں، تو ہدف کا 25% کم کر دیا جائے گا۔",
    myInfoText:"میری معلومات",
    bankIdText:"اکاؤنٹ",
    bankNameText:"بینک کا نام",
    payeeName:"وصول کنندہ کا نام",
    saveChanges:"تبدیلیاں محفوظ کریں",
    onMicTime:"مائک پر وقت",
    days: 'دن',
    tableItem: ['معلومات', 'میزبان', 'ڈیٹا'],
  }
}


// WEBPACK FOOTER //
// src/pages/app/tradeUnion/lang.js